module.exports = __webpack_public_path__ + "static/media/dashboard-active.d82678f8.svg";